// Model.js
// -----------------------
// @module Case
define("Tavano.TTPDPLeadTime.TTPDPLeadTime.Model", [
  "Backbone",
  "Utils"
], function (
  Backbone,
  Utils
) {
  "use strict";

  // @class Case.Fields.Model @extends Backbone.Model
  return Backbone.Model.extend({
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath("services/TTPDPLeadTime.Service.ss")
    ),
    validation: {
      zip: {
        required: true,
        msg: _("Zip is required").translate()
      },
      quantity: {
        required: true,
        msg: _("Quantity is required").translate()
      },
      email: {
        required: true,
        pattern: "email",
        msg: _("Email is required").translate()
      },
      full_name: {
        required: true,
        msg: _("Full Name is required").translate()
      },
      last_name: {
        required: true,
        msg: _("Last Name is required").translate()
      },
      role: {
        required: true,
        msg: _("Role is required").translate()
      },
      phone_number: {
        required: true,
        pattern: /^(?:\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{4})$/,
        msg: _("Phone Number must be in format (123) 456-7890 or 456-7890").translate()
      }

    }
  });
});
